<nb-card [nbSpinner]="loading" nbSpinnerStatus="primary" class="card-box">
    <nb-card-header class="content-header">
        <nb-icon class="icon" icon="people-outline" status="basic"></nb-icon>
        <span class="title">{{ title | translate }}</span>
        <nb-icon class="close" icon="close-outline" (click)="cancel()"></nb-icon>
    </nb-card-header>
    <ng-container *ngIf="!loading">
        <nb-card-body class="content-body">
            <div class="user-add-box">
                <div class="user-add-box__label">
                    <label for="email">{{'common.choose-users' | translate}}</label>
                </div>
                <div class="user-add-box__form">
                    <div class="user-add-box__form--select">
                        <nb-select [(selected)]="selectedUserEmail" size="small" status="primary"
                            placeholder="{{'common.choose-user' | translate}}">
                            <nb-option [value]="user.email"
                                *ngFor="let user of availableUsers | sortByOrder: 'email': 'isActive'"
                                [disabled]="!user.isActive">
                                <span class="select-text">{{user.text}}</span>
                            </nb-option>
                            <nb-option (click)="openOrganizationTab()">
                                <span class="select-text--organization"> {{'team.invite-user-to-your-organization' |
                                    translate}}</span>
                            </nb-option>
                        </nb-select>
                    </div>
                    <div class="user-add-box__form--button">
                        <button nbButton [disabled]="!selectedUserEmail" [status]="'primary'" [size]="'small'"
                            (click)="onShare.next(selectedUserEmail!)" tabindex="-1">
                            {{'common.share' | translate}}
                        </button>
                    </div>
                </div>
            </div>
            <div class="users-box">
                <div *ngFor="let user of assignedUsers | sortByOrder:'name': 'isActive': 'isOwner'; trackBy: trackByFn"
                    class="user-card" [attr.id]="user.id" [ngClass]="{'user-card--inactive' : !user.isActive}">
                    <div class="user-card__avatar">
                        <app-user-avatar [avatarUrl]="user.avatar" [isAvatar]="true" [userFullName]="user.name"></app-user-avatar>

                        <div class="avatar__icon--admin" *ngIf="user.isOwner">
                            <nb-icon icon="checkmark-outline" status="basic"></nb-icon>
                        </div>
                    </div>
                    <div class="user-card__name">
                        <label>{{user.name}}</label>
                    </div>
                    <div class="user-card__delete ms-auto" *ngIf="!user.isOwner">
                        <nb-icon nbTooltip="{{'common.remove-user' | translate}}" icon="close-circle-outline"
                            status="danger" size="small" class="cursor-pointer" (click)="onDeleteUser.next(user)">
                        </nb-icon>
                    </div>
                </div>
            </div>
        </nb-card-body>
        <nb-card-footer class="content-footer">
            <button nbButton [size]="'large'" [status]="'control'" [appearance]="'outline'" (click)="cancel()"
                tabindex="-1">
                {{'common.cancel' | translate}}
            </button>
        </nb-card-footer>
    </ng-container>
</nb-card>